import { render, staticRenderFns } from "./addonContent.vue?vue&type=template&id=fcac374e&scoped=true"
import script from "./addonContent.vue?vue&type=script&lang=js"
export * from "./addonContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcac374e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcac374e')) {
      api.createRecord('fcac374e', component.options)
    } else {
      api.reload('fcac374e', component.options)
    }
    module.hot.accept("./addonContent.vue?vue&type=template&id=fcac374e&scoped=true", function () {
      api.rerender('fcac374e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Addon/components/addonContent.vue"
export default component.exports